interface IAnalytics {
  event?: string;
  category?: string | null;
  action?: string | null;
  label?: string | null;
  value?: number | null;
  [key: string]: any;
}

export default function gtmTrackEvent(analytics: IAnalytics) {
  const { proxy } = useScriptGoogleTagManager();

  if (!proxy || !proxy.dataLayer) {
    console.warn('[GTM-Support]: dataLayer not found.');
    return;
  }

  const defaults: IAnalytics = {
    event: 'click_internal',
    category: null,
    action: null,
    label: null,
    value: null,
  };

  const merged = { ...defaults, ...analytics };

  // ✅ Push event to GTM dataLayer
  proxy.dataLayer.push(merged);

  // 🧠 Dev log
  if (import.meta.dev) {
    console.log(`%c[GTM-Support]: Dispatching event`, 'color:#00c853;font-weight:bold;', merged);
  }
}
